const getId = () => window?.location?.pathname?.split('/').pop();

export default getId;
